import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './index.css';
import { SidebarContent } from './SidebarContent';
import useStateRef from "react-usestateref";

const Sidebar = ({ inventoryUrl }) => {
  const navigate = useNavigate();
  const [selectedList, setSelectedList, selectedListRef] = useStateRef('movements');

  // TODO: fetch user info to get inventory_url

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    var location = window.location.pathname;

    var selected = "movements"
    if (location === "/" || location === "/movements") selected = "movements";
    else if (location === "/sales") selected = "sales";
    else if (location === "/inventory") selected = "inventory";

    setSelectedList(selected);
  }, [window.location.pathname])

  const clickMenu = (value) => {
    if (value.id === 'inventory') {
      window.open(inventoryUrl, '_blank');
    } else {
      navigate('/' + value.id);
    }
  };

  return (
    <div className="outlet-content-sidebar">
      <div className="sidebar-content">
        {SidebarContent.map((value, index) => (
          <div
            key={index}
            className={`sidebar-list ${selectedListRef.current === value.id ? 'selected' : ''}`}
            onClick={() => clickMenu(value)}
          >
            <div className={`sidebar-icon ${value.id}`}></div>
            <div className="sidebar-name">{value.name}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Sidebar;
